"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var prop_types_1 = __importDefault(require("prop-types"));

var get_css_1 = __importDefault(require("../get-css"));

var regex_1 = require("../utils/regex");

exports.propTypes = {
  margin: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
  marginBottom: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
  marginLeft: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
  marginRight: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
  marginTop: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
  marginX: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
  marginY: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
  padding: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
  paddingBottom: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
  paddingLeft: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
  paddingRight: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
  paddingTop: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
  paddingX: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
  paddingY: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number])
};
exports.propAliases = {
  margin: ['marginBottom', 'marginLeft', 'marginRight', 'marginTop'],
  marginX: ['marginLeft', 'marginRight'],
  marginY: ['marginBottom', 'marginTop'],
  padding: ['paddingBottom', 'paddingLeft', 'paddingRight', 'paddingTop'],
  paddingX: ['paddingLeft', 'paddingRight'],
  paddingY: ['paddingBottom', 'paddingTop']
};
exports.propValidators = {};

if (process.env.NODE_ENV !== 'production') {
  exports.propValidators.margin = function (value) {
    if (regex_1.spacesOutsideParentheses.test(value)) {
      return "multiple values (\u201C".concat(value, "\u201D) aren\u055At supported with \u201Cmargin\u201D. Use \u201CmarginX\u201D, \u201CmarginY\u201D \u201CmarginBottom\u201D, \u201CmarginLeft\u201D, \u201CmarginRight\u201D and \u201CmarginTop\u201D instead.");
    }

    return;
  };

  exports.propValidators.marginX = function (value) {
    if (regex_1.spacesOutsideParentheses.test(value)) {
      return "multiple values (\u201C".concat(value, "\u201D) aren\u055At supported with \u201CmarginX\u201D. Use \u201CmarginLeft\u201D and \u201CmarginRight\u201D instead.");
    }

    return;
  };

  exports.propValidators.marginY = function (value) {
    if (regex_1.spacesOutsideParentheses.test(value)) {
      return "multiple values (\u201C".concat(value, "\u201D) aren\u055At supported with \u201CmarginY\u201D. Use \u201CmarginBottom\u201D and \u201CmarginTop\u201D instead.");
    }

    return;
  };

  exports.propValidators.padding = function (value) {
    if (regex_1.spacesOutsideParentheses.test(value)) {
      return "multiple values (\u201C".concat(value, "\u201D) aren\u055At supported with \u201Cpadding\u201D. Use \u201CpaddingX\u201D, \u201CpaddingY\u201D \u201CpaddingBottom\u201D, \u201CpaddingLeft\u201D, \u201CpaddingRight\u201D and \u201CpaddingTop\u201D instead.");
    }

    return;
  };

  exports.propValidators.paddingX = function (value) {
    if (regex_1.spacesOutsideParentheses.test(value)) {
      return "multiple values (\u201C".concat(value, "\u201D) aren\u055At supported with \u201CpaddingX\u201D. Use \u201CpaddingLeft\u201D and \u201CpaddingRight\u201D instead.");
    }

    return;
  };

  exports.propValidators.paddingY = function (value) {
    if (regex_1.spacesOutsideParentheses.test(value)) {
      return "multiple values (\u201C".concat(value, "\u201D) aren\u055At supported with \u201CpaddingY\u201D. Use \u201CpaddingBottom\u201D and \u201CpaddingTop\u201D instead.");
    }

    return;
  };
}

var _marginTop = {
  className: 'mt',
  cssName: 'margin-top',
  jsName: 'marginTop'
};
var _marginRight = {
  className: 'mr',
  cssName: 'margin-right',
  jsName: 'marginRight'
};
var _marginBottom = {
  className: 'mb',
  cssName: 'margin-bottom',
  jsName: 'marginBottom'
};
var _marginLeft = {
  className: 'ml',
  cssName: 'margin-left',
  jsName: 'marginLeft'
};
var _paddingTop = {
  className: 'pt',
  cssName: 'padding-top',
  jsName: 'paddingTop'
};
var _paddingRight = {
  className: 'pr',
  cssName: 'padding-right',
  jsName: 'paddingRight'
};
var _paddingBottom = {
  className: 'pb',
  cssName: 'padding-bottom',
  jsName: 'paddingBottom'
};
var _paddingLeft = {
  className: 'pl',
  cssName: 'padding-left',
  jsName: 'paddingLeft'
};
exports.propEnhancers = {
  marginBottom: function marginBottom(value) {
    return get_css_1.default(_marginBottom, value);
  },
  marginLeft: function marginLeft(value) {
    return get_css_1.default(_marginLeft, value);
  },
  marginRight: function marginRight(value) {
    return get_css_1.default(_marginRight, value);
  },
  marginTop: function marginTop(value) {
    return get_css_1.default(_marginTop, value);
  },
  paddingBottom: function paddingBottom(value) {
    return get_css_1.default(_paddingBottom, value);
  },
  paddingLeft: function paddingLeft(value) {
    return get_css_1.default(_paddingLeft, value);
  },
  paddingRight: function paddingRight(value) {
    return get_css_1.default(_paddingRight, value);
  },
  paddingTop: function paddingTop(value) {
    return get_css_1.default(_paddingTop, value);
  }
};